export default class Utils {
  // TODO: we can use lodash deep_copy
  static copyObject(object) {
    return JSON.parse(JSON.stringify(object))
  }
}
